/**
 * Narrows an SDK response array to a field-scoped subset type.
 *
 * When calling SDK functions with a `fields` param, the API physically returns
 * only the requested fields but TypeScript still infers the full schema type.
 * This utility provides a single, type-safe narrowing point so consumers
 * never need double-casts through untyped intermediaries.
 *
 * @example
 * ```ts
 * const result = await getMarketsPage({ fields: MARKETS_FIELDS });
 * const items = scopeFields<MarketListItem>(result.data);
 * ```
 */
// ALLOW-UNKNOWN: structural narrowing — the API returns only requested fields
// but the SDK type is the full schema. This is the single canonical cast point.
export function scopeFields<TScoped>(data: ReadonlyArray<Record<string, unknown>>): TScoped[] {
  return data as TScoped[];
}
